<div *ngIf="form" [formGroup]="form" class="form-grid">
  <div class="d-flex flex-column gap-1">
    <label [for]="'startDate'" class="form-input-label" i18n>Employment Start</label>
    <app-datepicker-input
      formControlName="startDate"
      controlId="startDate"
      [error]="formSubmitted && form.controls.startDate.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.startDate.invalid"
      [customErrorMessages]="customErrorMessages.startDate"
      [errors]="form.controls.startDate.errors" />
  </div>
  <div class="d-flex flex-column gap-1">
    <label [for]="'contributionStartDate'" class="form-input-label" i18n>Contribution Start</label>
    <app-datepicker-input
      formControlName="contributionStartDate"
      controlId="contributionStartDate"
      [error]="formSubmitted && form.controls.contributionStartDate.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.contributionStartDate.invalid"
      [customErrorMessages]="customErrorMessages.contributionStartDate"
      [errors]="form.controls.contributionStartDate.errors" />
  </div>
  <div class="d-flex flex-column gap-1">
    <label [for]="'employmentTypeId'" class="form-input-label" i18n>Employment Type</label>
    <app-dropdown-input
      formControlName="employmentTypeId"
      controlId="employmentTypeId"
      [dropdowns]="employmentTypeDropdowns"
      [error]="formSubmitted && form.controls.employmentTypeId.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.employmentTypeId.invalid"
      [customErrorMessages]="customErrorMessages.employmentTypeId"
      [errors]="form.controls.employmentTypeId.errors" />
  </div>
  <div class="d-flex flex-column gap-1">
    <label [for]="'provinceOfEmploymentId'" class="form-input-label" i18n>Province of Employment</label>
    <app-dropdown-input
      formControlName="provinceOfEmploymentId"
      controlId="provinceOfEmploymentId"
      [dropdowns]="provinceDropdowns"
      [error]="formSubmitted && form.controls.provinceOfEmploymentId.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.provinceOfEmploymentId.invalid"
      [customErrorMessages]="customErrorMessages.provinceOfEmploymentId"
      [errors]="form.controls.provinceOfEmploymentId.errors" />
  </div>
  <div class="d-flex flex-column gap-1">
    <label [for]="'workFromHome'" class="form-input-label" i18n>Work from Home</label>
    <app-dropdown-input
      formControlName="workFromHome"
      controlId="workFromHome"
      [dropdowns]="yesNoDropdowns"
      [error]="formSubmitted && form.controls.workFromHome.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.workFromHome.invalid"
      [customErrorMessages]="customErrorMessages.workFromHome"
      [errors]="form.controls.workFromHome.errors" />
  </div>
  <div class="d-flex flex-column gap-1">
    <label [for]="'onLeave'" class="form-input-label" i18n>On Leave</label>
    <app-dropdown-input
      formControlName="onLeave"
      controlId="onLeave"
      [dropdowns]="yesNoDropdowns"
      [error]="formSubmitted && form.controls.onLeave.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.onLeave.invalid"
      [customErrorMessages]="customErrorMessages.onLeave"
      [errors]="form.controls.onLeave.errors" />
  </div>
  <ng-container *ngIf="form.controls.onLeave.value" formGroupName="leaveDetails">
    <div class="d-flex flex-column gap-1">
      <label [for]="'leaveTypeId'" class="form-input-label" i18n>Leave Type</label>
      <app-dropdown-input
        formControlName="leaveTypeId"
        controlId="leaveTypeId"
        [dropdowns]="leaveTypeDropdowns"
        [error]="formSubmitted && form.controls.leaveDetails?.controls.leaveTypeId.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.leaveDetails?.controls.leaveTypeId.invalid"
        [customErrorMessages]="customErrorMessages.leaveTypeId"
        [errors]="form.controls.leaveDetails?.controls.leaveTypeId.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label [for]="'startDate'" class="form-input-label" i18n>Leave Start</label>
      <app-datepicker-input
        formControlName="startDate"
        controlId="startDate"
        [error]="formSubmitted && form.controls.leaveDetails?.controls.startDate.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.leaveDetails?.controls.startDate.invalid"
        [customErrorMessages]="customErrorMessages.leaveStart"
        [errors]="form.controls.leaveDetails?.controls.startDate.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label [for]="'expectedReturnDate'" class="form-input-label" i18n>Expected Return</label>
      <app-datepicker-input
        formControlName="expectedReturnDate"
        controlId="expectedReturnDate"
        [error]="formSubmitted && form.controls.leaveDetails?.controls.expectedReturnDate.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.leaveDetails?.controls.expectedReturnDate.invalid"
        [customErrorMessages]="customErrorMessages.expectedReturnDate"
        [errors]="form.controls.leaveDetails?.controls.expectedReturnDate.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label [for]="'continuedContributions'" class="form-input-label" i18n>Continued Contributions</label>
      <app-dropdown-input
        formControlName="continuedContributions"
        controlId="continuedContributions"
        [dropdowns]="yesNoDropdowns"
        [error]="formSubmitted && form.controls?.leaveDetails.controls.continuedContributions.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls?.leaveDetails.controls.continuedContributions.invalid"
        [customErrorMessages]="customErrorMessages.continuedContributions"
        [errors]="form.controls?.leaveDetails.controls.continuedContributions.errors" />
    </div>
  </ng-container>
</div>
